export function tabbedSlider() {
    const $window = $(window);
    let $windowWidth = $window.width();
    const slider = $(".tabbed-slider");
    const sliderItems = slider.find(".item");
    let i = 0;
    let time = 10; // time for slide change in seconds
    let isPause, tick, percentTime;

    function changeSlide(index) {
        const parent = slider.find(".item").eq(index);
        const sliderImage = slider.next(".tabbed-slider-image");
        const image = parent.find('.hidden-info img');

        if (parent.hasClass("opened")) {
            parent.find(".hidden-info").slideUp();
            if (image && sliderImage) {
                sliderImage.removeClass('showed');
            }
        } else {
            setTimeout(() => {
                slider.find(".item").removeClass("opened");
                parent.addClass("opened");
            }, 400);
            sliderImage.removeClass('showed');
            slider.find(".item").find(".hidden-info").slideUp();
            parent.find(".hidden-info").slideDown();
            if (image && sliderImage) {
                let imageClone = image.clone();
                setTimeout(() => {
                    sliderImage.find("img").remove();
                    sliderImage.append(imageClone);
                }, 550);
                setTimeout(() => {
                    sliderImage.addClass('showed');
                }, 600);
            }
        }
    }

    function startPlay() {
        stopPlay();
        percentTime = 0;
        isPause = false;
        tick = setInterval(interval, 10);
    }

    function interval() {
        if (isPause === false) {
            percentTime += 1 / (time + 0.8);
            slider.find(".opened .progress").css({
                width: percentTime + "%"
            });
            if (percentTime >= 100) {
                i >= sliderItems.length - 1 ? i = 0 : i++;
                changeSlide(i);
                startPlay();
            }
        }
    }

    function stopPlay() {
        slider.find(".progress").css({
            width: 0 + '%'
        });
        clearTimeout(tick);
    }

    //play on click
    slider.on("click", ".item", function (e) {
        e.preventDefault();

        const $this = $(this);
        i = $this.index();

        if (!$this.hasClass("opened")) {
            if ($windowWidth > 1023) {
                setTimeout(startPlay, 400);
                setTimeout(() =>{
                    $this.addClass("slider-paused");
                    isPause = true;
                },400);
            }
            changeSlide(i);
        } else if (!$this.hasClass("slider-paused")) {
            if ($windowWidth > 1023) {
                $this.addClass("slider-paused");
                isPause = true;
            }
        } else {
            $this.removeClass("slider-paused");
            isPause = false;
        }
    });

    slider.find(".item").hover(function () {
        const $this = $(this);
        if ($this.hasClass("opened") && $("body").hasClass("no-touch")) {
            $this.addClass("slider-paused");
            isPause = true;
        }
    }, function () {
        slider.find(".slider-paused").removeClass("slider-paused");
        isPause = false;
    });


    //play on scroll
    const observer = new IntersectionObserver(entries => {
        if ($windowWidth > 1023) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    startPlay();
                } else {
                    isPause = true;
                }
            });
        }
    });

    slider.each(function () {
        observer.observe(this);
    });

    const mediaQuery = '(max-width: 1023px)';
    const mediaQueryList = window.matchMedia(mediaQuery);

    mediaQueryList.addEventListener('change', event => {
        $windowWidth = $window.width();
        if (event.matches) {
            stopPlay();
        }
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabbedSlider.js